import React, { useEffect } from 'react';

import { useLazyQuery } from '@apollo/client';

import { forceLogoutUnauthorizedUser } from 'helpers/functions/forceLogoutUnauthorizedUser';
import Client from 'helpers/queries/query.client';
import { useStore } from 'mobx/helpers';

const JwtChecker = () => {
  const store = useStore();
  const skipCondition = window.location.pathname.includes('resetPassword');
  const [loadUserInfo, userInfo] = useLazyQuery(
    Client.GET_USER_INFO,
    Client.GET_USER_INFO_DEFAULT_OPTIONS_V2(store.projectId, skipCondition),
  );

  useEffect(() => {
    if (userInfo && !userInfo.loading && userInfo.called && userInfo.data) {
      const userRole = userInfo.data.getUserByJWT?.role;
      const isDisabled = userInfo.data.getUserByJWT.isDisabled;
      /* 
        If the user has role "client" or user's account is disabled, force logout to prevent unauthorized access.
        This can happen when
        1. a user with role "client" logs in on another application
           that shares cookies: this application automatically recognizes the user via cookies,
           but does not allow login for users with role "client", so logout must be forced.
        2. user's account is disabled
      */
      if (userRole === 'client' || isDisabled) {
        store.setCheckingJwt(false);
        forceLogoutUnauthorizedUser(store);
        return;
      }
      /*
        If the user has a different role than the one stored in the session, force logout to prevent unauthorized access.
      */
      const previousRole = sessionStorage.getItem('loggedUserRole');
      if (previousRole && previousRole !== userRole) {
        store.setCheckingJwt(false);
        forceLogoutUnauthorizedUser(store);
        return;
      }
      sessionStorage.setItem('loggedUserRole', userRole);
      store.setLoggedUserJwtData({ userData: userInfo.data.getUserByJWT, checkingJwt: false });
    }
  }, [userInfo, store]);

  /* 
    load user info when the component is mounted not only when the visibility changes
  */
  useEffect(() => {
    if (!skipCondition) {
      store.setCheckingJwt(true);
      loadUserInfo();
    }
  }, [skipCondition, store, loadUserInfo]);

  function handleVisibilityChange() {
    if (!document.hidden && !skipCondition) {
      store.setCheckingJwt(true);
      loadUserInfo();
    }
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(() => {
    window.addEventListener('visibilitychange', handleVisibilityChange);
    return () => window.removeEventListener('visibilitychange', handleVisibilityChange);
  }, []);

  return <></>;
};

export default JwtChecker;
